function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-0.000335934023%",
  y1: "49.9998477%",
  x2: "99.999832%",
  y2: "49.9998477%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#43BDCF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#43BDCF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0.000251948401%",
  y1: "50%",
  x2: "99.9995801%",
  y2: "50%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#43BDCF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#43BDCF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-0.000335934023%",
  y1: "50%",
  x2: "99.999832%",
  y2: "50%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#43BDCF",
  stopOpacity: 0,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#43BDCF",
  offset: "100%"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Logos/Beyond-eyes-wit",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "2941-Beyond-Eyes_logo_white",
  transform: "translate(39.000000, 0.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.2761905,4.28357143 C10.2761905,5.17619048 9.84642857,6.03547619 8.77261905,6.5147619 C10.127619,6.92761905 10.6235714,8.3652381 10.6235714,9.09238095 C10.6235714,11.6704762 8.6897619,12.4966667 6.29404762,12.4966667 C4.45952381,12.4966667 2.64214286,12.4966667 0.807380952,12.4966667 L0.807380952,0.929047619 C2.6252381,0.929047619 4.45928571,0.929047619 6.29404762,0.929047619 C8.57428571,0.929047619 10.2761905,1.95380952 10.2761905,4.28357143 Z M2.95571429,5.57261905 L6.29404762,5.57261905 C7.66547619,5.57261905 8.11142857,4.99428571 8.11142857,4.33309524 C8.11142857,3.80428571 7.68166667,2.91214286 6.29404762,2.91214286 L2.95571429,2.91214286 L2.95571429,5.57261905 Z M2.95571429,10.4640476 L6.29404762,10.4640476 C7.18619048,10.4640476 8.45880952,10.1666667 8.45880952,9.07595238 C8.45880952,8.0347619 7.18619048,7.48952381 6.29404762,7.48952381 L2.95571429,7.48952381 L2.95571429,10.4640476 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.72,12.4964286 L16.0609524,12.4964286 C16.0609524,8.64619048 16.0609524,4.77904762 16.0609524,0.928809524 L24.72,0.928809524 L24.72,3.04404762 L18.2257143,3.04404762 L18.2257143,5.7047619 L24.4885714,5.7047619 L24.4885714,7.73714286 L18.2257143,7.73714286 L18.2257143,10.3478571 L24.72,10.3478571 L24.72,12.4964286 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "35.1419048 5.705 38.2154762 0.929047619 40.8430952 0.929047619 40.8430952 1.02809524 36.232619 7.72095238 36.232619 12.4964286 34.0514286 12.4964286 34.0514286 7.72095238 29.6059524 1.02809524 29.6059524 0.929047619 32.2004762 0.929047619"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.0561905,6.77880952 C56.0233333,9.7697619 54.1892857,12.7609524 50.1238095,12.7609524 C46.0583333,12.7609524 44.1747619,9.83595238 44.1747619,6.795 C44.1747619,3.75452381 46.1247619,0.697619048 50.1238095,0.697619048 C54.1064286,0.697857143 56.0892857,3.7547619 56.0561905,6.77880952 Z M46.3230952,6.82833333 C46.372619,8.72880952 47.3971429,10.7614286 50.1238095,10.7614286 C52.8504762,10.7614286 53.875,8.71214286 53.9080952,6.81214286 C53.9409524,4.86214286 52.8504762,2.68095238 50.1238095,2.68095238 C47.3971429,2.68095238 46.2735714,4.87880952 46.3230952,6.82833333 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "67.7266667 0.912619048 69.9078571 0.912619048 69.9078571 12.4966667 68.5528571 12.4966667 68.5528571 12.5130952 62.4719048 4.69714286 62.4719048 12.4969048 60.2904762 12.4969048 60.2904762 0.929285714 62.0588095 0.929285714 67.7269048 8.10142857 67.7269048 0.912619048"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.3919048,6.61380952 C85.4414286,9.53833333 83.6569048,12.4964286 79.6078571,12.4964286 C78.1869048,12.4964286 76.4845238,12.4964286 75.0638095,12.4964286 L75.0638095,0.928809524 C76.4847619,0.928809524 78.1871429,0.928809524 79.6078571,0.928809524 C83.5740476,0.929047619 85.342381,3.7547619 85.3919048,6.61380952 Z M77.2285714,10.397619 L79.6078571,10.397619 C82.2354762,10.397619 83.2766667,8.48071429 83.2271429,6.59690476 C83.177619,4.79595238 82.12,2.99452381 79.6078571,2.99452381 L77.2285714,2.99452381 L77.2285714,10.397619 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.49952381,29.2442857 L0.84047619,29.2442857 C0.84047619,25.3940476 0.84047619,21.5269048 0.84047619,17.6766667 L9.49952381,17.6766667 L9.49952381,19.7919048 L3.0052381,19.7919048 L3.0052381,22.452619 L9.26809524,22.452619 L9.26809524,24.485 L3.0052381,24.485 L3.0052381,27.0957143 L9.49952381,27.0957143 L9.49952381,29.2442857 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "20.3409524 22.452619 23.4145238 17.6766667 26.0421429 17.6766667 26.0421429 17.7757143 21.4316667 24.4685714 21.4316667 29.2440476 19.2504762 29.2440476 19.2504762 24.4685714 14.805 17.7757143 14.805 17.6766667 17.3995238 17.6766667"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.5602381,29.2442857 L30.9011905,29.2442857 C30.9011905,25.3940476 30.9011905,21.5269048 30.9011905,17.6766667 L39.5602381,17.6766667 L39.5602381,19.7919048 L33.0659524,19.7919048 L33.0659524,22.452619 L39.3288095,22.452619 L39.3288095,24.485 L33.0659524,24.485 L33.0659524,27.0957143 L39.5602381,27.0957143 L39.5602381,29.2442857 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.4557143,20.4695238 C52.0592857,19.8088095 50.9683333,19.1809524 49.712619,19.1809524 C48.0935714,19.1809524 47.3164286,19.8583333 47.3164286,20.7178571 C47.3164286,21.7259524 48.5064286,22.0064286 49.8945238,22.1719048 C52.3071429,22.4692857 54.5545238,23.0971429 54.5545238,25.8571429 C54.5545238,28.4347619 52.2742857,29.5419048 49.6961905,29.5419048 C47.3330952,29.5419048 45.5154762,28.8147619 44.6559524,26.6997619 L46.4738095,25.757619 C46.9861905,27.0302381 48.3242857,27.5921429 49.7292857,27.5921429 C51.1007143,27.5921429 52.3897619,27.1128571 52.3897619,25.8571429 C52.3897619,24.7664286 51.2495238,24.3202381 49.712619,24.1547619 C47.3495238,23.8738095 45.1685714,23.2459524 45.1685714,20.6514286 C45.1685714,18.2721429 47.5152381,17.2966667 49.6466667,17.2804762 C51.447619,17.2804762 53.315,17.7928571 54.1907143,19.577619 L52.4557143,20.4695238 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "2941-Beyond-Eyes_icoon_full-colour",
  transform: "translate(0.692308, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#EA3544",
  x: 0.0741573034,
  y: 0.133483146,
  width: 15.0201124,
  height: 29.7475281
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFCC2D",
  cx: 15.1865169,
  cy: 22.4948315,
  r: 7.45179775
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFCC2D",
  cx: 15.1865169,
  cy: 7.52719101,
  r: 7.45179775
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "url(#linearGradient-1)",
  points: "28.5785393 18.6586517 28.5785393 11.282809 15.1997753 11.282809 15.1997753 18.6586517"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "url(#linearGradient-2)",
  points: "28.6022472 29.8810112 28.6022472 22.5050562 15.2233708 22.5050562 15.2233708 29.8810112"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "url(#linearGradient-3)",
  points: "28.5785393 7.5094382 28.5785393 0.133483146 15.1997753 0.133483146 15.1997753 7.5094382"
}))));
function SvgBeyondEyeslogowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "30px",
    viewBox: "0 0 124 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logos/Beyond eyes wit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondEyeslogowhite);
export default __webpack_public_path__ + "static/media/Beyond Eyes logo white.e01e4a74b3ec10457f12d7e3c2a497ed.svg";
export { ForwardRef as ReactComponent };